import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _19mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"19mp"}/>
}
